import { Spinner, Stack } from 'component-library';
import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { SuspenseBoundary } from '@/components/SuspenseBoundary';
import { usePathSet } from '@/hooks/usePathSet';
import { SignedInPageLayout } from '@/layout/signed-in-page';
import { useMenuItems } from '@/pages/shared/hooks/useMenuItems';

import { WorkstreamForm } from './components/WorkstreamForm';
import { useWorkstreamMilestoneSteps } from './hooks/useWorkstreamMilestoneSteps';

export const EditWorkstreamPage = () => {
  const { t } = useTranslation();
  const menuItems = useMenuItems();
  const paths = usePathSet();

  return (
    <SignedInPageLayout
      items={menuItems}
      navBarProps={{
        title: t('global.ui.buttons.edit'),
        backPath: paths.workstreams,
        showSearchBar: false,
      }}
    >
      <Stack spacing={10}>
        <ErrorBoundary fallback={null}>
          <SuspenseBoundary
            fallback={
              <Stack centerMain>
                <Spinner size={10} />
              </Stack>
            }
          >
            <EditWorkstreamContent />
          </SuspenseBoundary>
        </ErrorBoundary>
      </Stack>
    </SignedInPageLayout>
  );
};

const EditWorkstreamContent = () => {
  const { workstreamId } = useParams<{ workstreamId: string }>();
  const workstream = useWorkstreamMilestoneSteps(workstreamId);

  return <WorkstreamForm workstream={workstream} />;
};
